import musicPlay from './musicPlay';
import Vue from 'vue';

let musicPlayInstance;
function getmusicPlayInstance (ossurl) {
        const _props =  {
            ossurl:ossurl
        };
        const Instance = new Vue({
            render (h) {
                return h(musicPlay, {
                    props: _props
                });
            }
        });
        
        const component = Instance.$mount();
        document.body.appendChild(component.$el);
        const notification = Instance.$children[0];
        return {
            destroy () {
                notification.close()
            }
        };
}


export default {
    name: 'musicPlay',
    show (ossurl) {
        this.musicPlayInstance=getmusicPlayInstance(ossurl);
        
        return musicPlayInstance;
    },
    close () {
        this.musicPlayInstance.destroy()
    }
};


// WEBPACK FOOTER //
// ./src/components/musicPlay/index.js